import script from "./LoginScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginScreen.vue?vue&type=script&setup=true&lang=js"

import "./LoginScreen.vue?vue&type=style&index=0&id=daa70880&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-daa70880"]])

export default __exports__